import React from 'react'
import SeoHead from '../components/SeoHead'
import WaveDivider from '../components/WaveDivider'
import { localizeTree } from '../i18n/localizeTree'

export default function BetingelserPage({ lang = 'da' }) {
  return localizeTree((
    <>
      <SeoHead pageId="terms" lang="da" />

      {/* Header Banner */}
      <section className="subpage-hero bg-[#F7ECEE] py-12 sm:py-16 border-b border-[#C68D94]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-script text-5xl sm:text-6xl text-[#3E3435] font-normal my-3">
            Betingelser
          </h1>
          <WaveDivider className="text-[#C68D94]/50 mx-auto" />
        </div>
      </section>

      {/* Content Section */}
      <section className="py-14 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto rounded-3xl p-8 sm:p-12 space-y-6 text-xs sm:text-sm text-[#3E3435]/90 font-light leading-relaxed">
          <p className="italic text-stone-600 text-sm sm:text-base border-l-4 border-[#C68D94] pl-4 py-1">
            Dine personlige data vil hjælpe os når vi skal kontakte dig. Vi lover at passe på dine data og holde dem sikret.
          </p>

          <div className="pt-4 border-t border-[#C68D94]/15 space-y-3">
            <h2 className="font-semibold text-base text-[#3E3435]">Kontakt & Information</h2>
            <p>
              Har du spørgsmål til vores betingelser, bestillinger eller håndtering af henvendelser, er du altid velkommen til at kontakte os:
            </p>
            <div className="bg-[#FDF8F7] p-4 rounded-2xl border border-[#C68D94]/15 space-y-1">
              <p className="font-medium text-[#3E3435]">Fanø Chokolade</p>
              <p>Strandvejen 58, 6720 Fanø</p>
              <p>CVR: 42370509</p>
              <p>
                Tlf:{' '}
                <a href="tel:60224704" className="text-[#A35D67] hover:underline whitespace-nowrap font-medium">
                  60 22 47 04
                </a>
              </p>
              <p>
                Email:{' '}
                <a href="mailto:karina@fanoechokolade.dk" className="text-[#A35D67] hover:underline whitespace-nowrap font-medium">
                  karina@fanoechokolade.dk
                </a>
              </p>
            </div>
          </div>

        </div>
      </section>
    </>
  ), lang)
}
